import * as React from "react";
import Box from "@mui/material/Box";
import { useInView } from "framer-motion";
import {
  INNO_AL_RE,
  IL_BARBIERE_DI_SIVIGLIA,
  LOSTERIA_DI_MARECHIARO,
  LA_MOLINARA,
  IL_MATRIMONIO_INASPETTATO,
  CUCINA,
} from "../../../utils/imageImports";
import { useMediaQuery } from "@mui/material";
import MasonryGrid from "../MasonryGrid/MasonryGrid";
const tabToFolderMap = {
  room1: INNO_AL_RE,
  room2: IL_BARBIERE_DI_SIVIGLIA,
  room3: LOSTERIA_DI_MARECHIARO,
  room4: LA_MOLINARA,
  room5: IL_MATRIMONIO_INASPETTATO,
  room6: CUCINA,
};

export default function CarouselRooms({ index }) {
  const [value, setValue] = React.useState(index);

  const [photos, setPhotos] = React.useState([]);
  const containerRef = React.useRef(null);
  const isInView = useInView(containerRef, {
    once: true, // Carica le immagini solo una volta quando in vista
    margin: "100px 100px -50px 0px",
  });

  const isTabletOrMobile = useMediaQuery("(max-width: 1090px)"); // Definisci il breakpoint per tablet e mobile

  React.useEffect(() => {
    if (isTabletOrMobile) {
      setPhotos(tabToFolderMap[index]);
    }

    if (isInView && tabToFolderMap[value]) {
      setPhotos(tabToFolderMap[value]);
    }
  }, [value, isInView, isTabletOrMobile, index]);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        zIndex: 1000,
        marginTop: isTabletOrMobile ? 0 : 5,
        pointerEvents: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // height: isTabletOrMobile ? "50vh" : undefined,
      }}
    >
      {isInView && (
        <React.Suspense
          fallback={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: isTabletOrMobile ? "40vh" : "100vh",

                fontSize: "20px",
                color: "#ffffff",
              }}
            >
              Loading...
            </div>
          }
        >
          <MasonryGrid photos={photos} />
        </React.Suspense>
      )}
    </Box>
  );
}
